<template>
  <div>
    <div v-if="call.dtmf">
      <keypad
        :username = "username"
        :number = "dtmfNumber"
        :digit = "dtmfDigit"
        :clear = "dtmfClear"
        :backspace = "dtmfBackspace"
        >
      </keypad>
      <div class="row phone-row" style="margin: 0 auto 11px 1em !important; text-align: left !important;">
        <div class="col-12">
          <b-button variant="primary" @click="dtmfKeyboard">
            <i class="mdi mdi-arrow-left"></i>
          </b-button>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row phone-row">
        <div class="number col-12" style="min-height: 2.2em;">
          <span v-if="number.length < 12">{{ number === `DEVCONF${username}` ? $t('onCall.conferenceCall') : (number === '9999999' ? 'Voicemail' : number) }}</span>
          <span style="font-size: 1.4rem !important;" v-else>{{ number.substring(number.length - 16, number.length) }}</span>
        </div>
      </div>
      <div class="row phone-row">
        <div class="time col-12" style="min-height: 2.5rem;">
          {{ timeFormated || '&nbsp;' }}
        </div>
      </div>
      <div class="row phone-row">
        <div class="col-4 dig">
          <i class="mdi mdi-pause" style="color: red;" v-tooltip="$t('onCall.unHold')" aria-hidden="true" @click="holdCall" v-if="hold"></i>
          <i class="mdi mdi-pause" v-tooltip="$t('onCall.hold')" aria-hidden="true" @click="holdCall" v-else></i>
        </div>
        <div class="col-4 dig">
          <i class="mdi mdi-microphone-off" style="color: red;" v-tooltip="$t('onCall.unMute')" aria-hidden="true" @click="muteCall" v-if="mute"></i>
          <i class="mdi mdi-microphone-off" v-tooltip="$t('onCall.mute')" aria-hidden="true" @click="muteCall" v-else></i>
        </div>
        <div class="col-4 dig">
          <i class="mdi mdi-phone-forward" v-tooltip="$t('onCall.transfer')" @click="transfer" aria-hidden="true"></i>
        </div>
      </div>
      <div class="row phone-row" style="margin-top: 40px !important;">
          <div class="col-4 dig">
          <i class="mdi mdi-video-off" style="color: grey;" aria-hidden="true" v-if="!isVideo"></i>
          <i class="mdi mdi-video-off" v-tooltip="$t('onCall.videoOff')" aria-hidden="true" @click="toggleCamera" v-if="isVideo && camera"></i>
          <i class="mdi mdi-video-off" style="color: red;" v-tooltip="$t('onCall.videoOn')" aria-hidden="true" @click="toggleCamera" v-if="isVideo && !camera"></i>
        </div>
        <div class="col-4 dig">
          <i class="mdi mdi-dialpad" v-tooltip="$t('onCall.dial')" aria-hidden="true" @click="dtmfKeyboard"></i>
        </div>
        <div class="col-4 dig">
          <i class="mdi mdi-call-merge" style="color: grey;" aria-hidden="true" v-if="!hold"></i>
          <i class="mdi mdi-call-merge" v-tooltip="$t('onCall.mergeCalls')" aria-hidden="true" @click="merge" v-else></i>
        </div>
      </div>
      <div class="row phone-row" style="margin-top: 95px !important; margin-bottom: 24px !important;">
        <div class="col-12">
          <b-button variant="danger" @click="hangupCall">
            <i class="mdi mdi-phone-hangup" aria-hidden="true"></i>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import keypad from './Keypad'

export default {
  name: 'on-call',
  components: {
    keypad
  },
  props: {
    call: {
      type: Object
    },
    username: {
      type: String,
      required: true
    },
    number: {
      type: String,
      default: ''
    },
    hold: {
      type: Boolean
    },
    mute: {
      type: Boolean
    },
    timeFormated: {
      type: String,
      default: ''
    },
    holdCall: {
      type: Function
    },
    muteCall: {
      type: Function
    },
    toggleCamera: {
      type: Function
    },
    transfer: {
      type: Function
    },
    hangupCall: {
      type: Function
    },
    dtmfNumber: {
      type: String,
      default: ''
    },
    dtmfDigit: {
      type: Function
    },
    dtmfClear: {
      type: Function
    },
    dtmfBackspace: {
      type: Function
    },
    merge: {
      type: Function
    },
    isVideo: {
      type: Boolean
    },
    camera: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  methods: {
    dtmfKeyboard () {
      this.call.dtmf = !this.call.dtmf
    }
  }
}
</script>

<style scoped>

.digit,
.dig {
  cursor: pointer;
  font-size: 2em;
}

.digit:active,
.dig:active {
  background-color: #e6e6e6;
}

.time {
  float: center;
  padding: 10px 10px;
  width: 100%;
  font-size: 2rem;
}

.number {
  padding: 10px 10px;
  width: 100%;
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
  color: transparent;
  text-shadow: 0 0 0 #1976d2;
}

.btn.btn-rounded {
  border-radius: 10px;
  color: #ffffff;
  width: 100%;
  height: 42px;
  cursor: pointer;
}

.phone-row {
  margin: 20px auto !important;
  max-width: 320px !important;
  clear: both !important;
  text-align: center !important;
  font-family: 'Exo' !important;
}

.phone-btn {
  min-width: 280px;
  padding: 0.7rem 0.2rem;
}

</style>
